import { toast } from "react-toastify";
import { createGlobalStyle } from "styled-components";
import "react-toastify/dist/ReactToastify.css";

export const GlobalStyle = createGlobalStyle`
  .Toastify__toast--error {
    background-color: #FE3030 !important;
  }
  .Toastify__toast-body {
    color: white !important;
    font-family: 'Roboto', sans-serif !important;
    font-weight: normal !important;
  }
  .Toastify__progress-bar--animated.Toastify__progress-bar--error {
    background: white !important;
  }
  .Toastify__toast--error .Toastify__toast-icon {
    color: white !important;
  }
  .Toastify__toast--error .Toastify__close-button {
    color: white !important;
  }
`;

const ToastError = (message) => {
  return (
    <>
      <GlobalStyle />
      {toast.error(message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      })}
    </>
  );
};

export default ToastError;
